import isEmpty from "lodash.isempty";

export const SESSION_NAME = "GreenClub";
export const GREEN_CLUB_URL = "https://greenclub.pottsalat.de";

const initialState = {
    hideOnboardingPopup: false,
    hideGreenClubMaxCapacityPopup: false,
    hideGreenClubComponents: false,
};

const update = (state) =>
    sessionStorage.setItem(SESSION_NAME, JSON.stringify(state));

const get = () => {
    return JSON.parse(sessionStorage.getItem(SESSION_NAME));
};

const isSet = () => {
    try {
        const value = get();
        return !isEmpty(value) && !!value;
    } catch (error) {
        return false;
    }
};

export default { initialState, update, get, isSet };
